/**
 * External dependencies
 */
import {
	ButtonEditHelper
} from '~cartzillagb/components'
import {
	withUniqueClass,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { i18n } from 'cartzillagb'

/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n'
import { RichText } from '@wordpress/block-editor'
import { applyFilters } from '@wordpress/hooks'
import { compose } from '@wordpress/compose'
import { getBootstrapClasses, range } from '~cartzillagb/util'


const save = props => {
	const {
		className, attributes,
	} = props

	const {
		enableContainer,
		enableSubscriberImages,
		enableSubscriberCount,
		enableButton,
		enableBadge,
		enableVideoTitle,

		// Title.
		showTitle = true,
		title = '',
		titleTag = 'h3',

		// Button.
		showHeaderButton = false,
		lgColumns,
		limit,
		mediaURL,
		subscriberCount,
		text,
		headerButtonText,
		mediaURL1
	} = attributes


	const mainClasses = classnames( [
		className,
		'pb-5 mb-md-3',
		'youtub-feed-block'
	], applyFilters( 'cartzillagb.youtube-feed-block.main-block.classes', {
		'container': enableContainer,
	}, props ) )

	const titleComp = showTitle && (
		<RichText.Content
			tagName={ titleTag || 'h2' }
			value={ title }
			className={ classnames( [
				'czgb-youtube-feed__title',
				showHeaderButton ? 'h4 mb-3' : 'h4 mb-3 text-center',
			] ) }
		/>
	)


	const headerButtonComp = showHeaderButton && ! RichText.isEmpty( headerButtonText ) &&
		<ButtonEditHelper.Content
			attrNameTemplate={ `headerButton%s` }
			blockAttributes={ props.attributes }
		/>


	const buttonComp = enableButton &&(
		<ButtonEditHelper.Content
			attrNameTemplate="button1%s"
            blockAttributes={ props.attributes }
		/>
	)
	const headerComp = showTitle && showHeaderButton ? (
		<div className="czgb-youtube-feed__header d-flex flex-wrap justify-content-between align-items-center pt-3 pb-2" >
			{ titleComp }
			<div className="mb-3" >
				{ headerButtonComp }
			</div>
		</div>
	) : ( showTitle ? (
		titleComp
	) : ( showHeaderButton ? (
		<div className="czgb-youtube-feed__header d-flex flex-wrap justify-content-between align-items-center pt-3 pb-2" >
			{ headerButtonComp }
		</div>
	) : '' ) )


	const content = range( 1, ( limit ) + 1 ).map( i => {
		const imageURL = attributes[ `imageURL${ i }` ]
		const badge = attributes[ `badge${ i }` ]
		const videoTitle = attributes[ `videoTitle${ i }` ]
		const link = attributes[ `link${ i }` ] !== undefined ? attributes[ `link${ i }` ]  : '#'
		let defaultTimer = ''
		let defaultVideoTitle = ''
		

		if ( (i % 4 ) === 1 ) {
			defaultTimer=(__("6.16", i18n))  
			defaultVideoTitle =  (__("5 New Cool Gadgets You Must See on Cartzilla - Cheap Budget", i18n))          
		}

		if ( (i % 4 ) === 2 ) {
			defaultTimer=(__("7.27", i18n)) 
			defaultVideoTitle =  (__("5 Super Useful Gadgets on Cartzilla You Must Have in 2020", i18n))            
		}

		if ( (i % 4 ) === 3 ) {
			defaultTimer=(__("6.20", i18n))
			defaultVideoTitle =  (__("Top 5 New Amazing Gadgets on Cartzilla You Must See", i18n))             
		}

		if ( (i % 4 ) === 0 ) {
			defaultTimer=(__("5.67", i18n))
			defaultVideoTitle =  (__("5 Amazing Construction Inventions and Working Tools Available...", i18n))             
		}
		const bootstrapClass = getBootstrapClasses( undefined, undefined, undefined, lgColumns )
		const blockAdditionalClasses = classnames( [
           
            (i > 3) ? 'd-lg-none' : '',
              
        ])

		return (
			<div className={ `${ bootstrapClass } ${ blockAdditionalClasses } col-6 mb-3` }  key={ i }>
				<a className="video-cover video-popup-btn d-block text-decoration-0 px-2" href={ link }>
					<div className="video-cover-thumb mb-2">
						{ enableBadge && 
							<RichText.Content
								tagName='span'
								value={ badge || defaultTimer }
								className="badge badge-dark"
							/>
						}

						<img src={ imageURL } className="w-100" alt={ __( 'Video cover', i18n ) } />
					</div>

					{ enableVideoTitle && 
						<RichText.Content
							tagName='h6'
							value={ videoTitle || defaultVideoTitle }
							className="font-size-sm pt-1"
						/>
					}
				</a>
			</div>
		)

	} ) 
	
	return (
		<div className={ mainClasses }>
   			<div className="border rounded-lg p-3">
             	<div className="row">
             		<div className="col-md-4 mb-3 mb-md-0">
	             		<div className="bg-secondary p-5 text-center">
		             		<img src={ mediaURL } className="d-block mb-4 mx-auto" width="120" alt={ __( 'YouTube', i18n ) } />
							{ ( enableSubscriberImages || enableSubscriberCount ) &&
								<div className="media justify-content-center align-items-center mb-4">
									{ enableSubscriberImages &&
										<img src={ mediaURL1 } className="mr-2" width="126" alt={ __( 'YouTube Subscribers', i18n ) } />
									}
									{ enableSubscriberCount &&
										<RichText.Content
											tagName='span'
											value={ subscriberCount || "250k+" }
											className="font-size-sm"
										/>
									}
								</div>
							}

							<div className="mb-3">{ buttonComp }</div>
								<RichText.Content
									tagName='p'
									value={ text || "*View latest gadgets reviews available for purchase in our store." }
									className="font-size-sm mb-0"
								/>
	             		</div>
             		</div>
             		<div className="col-md-8">
             			{ headerComp }
             			<div className="row no-gutters">
	             				{ content }
	             			
             			</div>
             		</div>
             	</div>
           	</div>
    	</div>
	)  
}

export default compose(
	withUniqueClass,
)( save )